import * as React from 'react';
import { SVGProps } from 'react';

const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.5 3.5V2.1c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C4.26.5 4.54.5 5.1.5h3.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437c.109.214.109.494.109 1.054v3.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C9.74 7.5 9.46 7.5 8.9 7.5H7.5m-5.4 3h3.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C7.5 9.74 7.5 9.46 7.5 8.9V5.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C6.74 3.5 6.46 3.5 5.9 3.5H2.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C.5 4.26.5 4.54.5 5.1v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CopyIcon;
